'use es6';

import { useDispatch } from 'react-redux';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { clearAddSectionMissingModuleErrors } from 'ContentEditorUI/redux/actions/appActions';
import { hydrateFailedCustomSectionTreeWithoutMissingModuleSchemas } from 'ContentEditorUI/redux/actions/moduleActions';
import UsageTracker from 'ContentEditorUI/utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function AddSectionModuleSchemaMissingErrorModal({
  missingModuleSchemaErrorCount
}) {
  const dispatch = useDispatch();
  const bodyMessageKey = missingModuleSchemaErrorCount > 1 ? 'plural' : 'single';
  const hydrateSectionCallback = () => {
    dispatch(hydrateFailedCustomSectionTreeWithoutMissingModuleSchemas());
    UsageTracker.trackEditorInteraction({
      action: 'Sections Action',
      event: 'added-section-with-missing-modules'
    });
  };
  return /*#__PURE__*/_jsxs(Modal, {
    use: "danger",
    width: 525,
    children: [/*#__PURE__*/_jsx(DialogHeader, {
      children: /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "addSectionPanel.error.modal.title"
        })
      })
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `addSectionPanel.error.modal.body.${bodyMessageKey}`
      })
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(Button, {
        use: "primary",
        onClick: hydrateSectionCallback,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "addSectionPanel.error.modal.confirm"
        })
      }), /*#__PURE__*/_jsx(Button, {
        onClick: () => dispatch(clearAddSectionMissingModuleErrors()),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "addSectionPanel.error.modal.reject"
        })
      })]
    })]
  });
}